'use client';

import { ProjectModel } from "@/lib/models/Project";
import { ROUTES, projectPath } from "@/lib/routes";
import { useContentSize } from "@/components/SizeProvider";
import { formatDesktopTitle, getTitleFontSize } from "@/lib/utils/typography";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useLenis } from "lenis/react";

interface Props {
  projects: ProjectModel[];
  activeProjectId: number;
}

export default function ListProject(props: Props) {
  const { projects, activeProjectId } = props;
  const { width: widthContent } = useContentSize();
  const pathname = usePathname();
  const isExperimentsHighlighted = pathname === '/' || pathname.startsWith('/project-detail');
  const lenis = useLenis();

  // Reset scroll on click too, so re-selecting the route you're already on
  // (where the pathname doesn't change) still snaps back to the top.
  const scrollToTop = () => {
    lenis?.scrollTo(0, { immediate: true });
    if (typeof window !== 'undefined') window.scrollTo(0, 0);
  };

  return (
    <div className={'menu-wrapper'}>
      <p className='text-gray text-gray-heading letter-scrambler'>{"\\\\MENU\\\\"}</p>
      <Link
        href={ROUTES.home}
        onClick={scrollToTop}
        className={`title-experiments ${isExperimentsHighlighted ? 'title-experiments-active' : ''}`}
        style={{ fontSize: getTitleFontSize(widthContent, { ceil: false }) }}
      >
        <h2 className="letter-scrambler">EXPERIMENTS <span className="experiments-view-all">[VIEW ALL]</span></h2>
      </Link>
      <ol className={'project-list'}>
        {projects.map((item, index: number) => {
          return (
            <li
              className={`project-title ${activeProjectId === item.id ? 'project-title-active' : ''}`}
              key={item.id}
            >
              <Link
                href={projectPath(item.slug)}
                onClick={scrollToTop}
                prefetch={false}
                className="letter-scrambler"
              >
                {`${(index + 1).toString().padStart(2, '0')}`}\{formatDesktopTitle(item.projectTitle)}
              </Link>
            </li>
          )
        })}
      </ol>
      <p className='text-gray text-gray-separator'>{"<>"}</p>
    </div>
  )
};
